module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/178PQaP/cover.jpeg?1684514752001",
      "alt": "This image is the cover for the book Unparalleled Martial Arts, Book 29"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unparalleled Martial Arts, Book 29\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("In the martial arts world, the strong are respected. Force and power are closely related. Only the strong can formulate the rules of the game.")])]), _c('p', [_vm._v("A young man rises from the bottom. He is not afraid of power, and strives to improve his strength. He fights with all the powerful ones, defeats others one by one, eventually becomes the king, and formulates his own rules.")]), _c('p'), _c('p', [_c('strong', [_vm._v("☆About the Author☆")])]), _c('p'), _c('p', [_vm._v("Xin Ban Hongshuangxi is a well-known online novelist. He has written many works, mostly fantasy novels. His works have been well received by readers for his outstanding imagination and humorous writing style.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Xin BanHongShuangXi, Babel Novel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Funstory\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0